import { IMeetingVm } from "../models/response/meeting/IMeetingVm";
import { apiClient } from "./apiClient";

export const meetingApi = {
    saveChange: (payload: IMeetingVm) => apiClient.post('meeting', payload),
    select: () => apiClient.get("meeting"),
    selectDetail: (id: number) => apiClient.get("meeting/" + id.toString()),
    selectRegisterResult: (id: number) => apiClient.get("meeting/" + id.toString() +"/history"),
    delete: (id: number) => apiClient.delete("meeting/" + id.toString()),
    sendNotify: (id: number) => apiClient.post("meeting/" + id.toString()+'/notify')
}